module.exports = __webpack_public_path__ + "static/media/costInGeneral.dced298c.mp3";